import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Typography,
  useTheme,
} from "@mui/material";
import { useContract } from "../Contracts/Provider";
import { useSite } from "./Provider";
import { useAuth } from "../../services/auth";
import TabsList from "../../ui/TabsList";
import InfoSite from "./InfoSite";
import ErrorsList from "../../ui/ErrorsList";
import { useGate } from "../Gates/Provider";
import { useDisCount } from "../DisCounts/Provider";
import { useZone } from "../Zones/Provider";
import { useAccount } from "../Accounts/provider";
import { useVoidReason } from "../VoidReason/Provider";
import { useTemplateMess } from "../TemplateMessage/Provider";
import SMSInfo from "../SMS/SMSInfo";
import { useWebContent } from "../WebContent/provider";
import WebContentInfo from "../WebContent/WebContentInfo";
import CustomTable from "../../ui/CustomTable";

import ActiveCell from "../Companies/CompanyTable/ActiveCell";
import StyledType from "../Gates/StyledType";
import RenderMess from "../TemplateMessage/Render/RenderMess";
import DownloadLink from "./DownloadLink";
import StartContract from "./Render/StartContract";
import EndContract from "./Render/EndContract";
import FirstReminderCell from "./Render/FirstReminderCell";
import LastReminder from "./Render/LastReminder";
import EmployeeRoles from "./Render/EmployeeRoles";
import EmployeeHourlyRate from "./Render/EmployeeHourlyRate";
import EmployeeZones from "./Render/EmployeeZones";
import EmployeeUpdateDate from "./Render/EmployeeUpdateDate";
import { useEmployees } from "../employee/Provider";
import { handleErrorResponse } from "../../utilities/functions";
import ModalBox from "../../ui/ModalBox";

const TAB_CONTRACTS = "Contracts";
const TAB_EMPLOYEES = "Employees";
const TAB_GATES = "Gates";
const TAB_DISCOUNT = "Discounts";
const TAB_ZONES = "Zones";
const TAB_ACCOUNT = "Accounts";
const TAB_ROLES = "Roles";
const TAB_TEMPLATE_MESSAGES = "Template Messages";
const TAB_VOID_REASONS = "Void Reasons";
const TAB_SMS_PROVIDERS = "SMS Provider";
const TAB_WEB_CLIENT = "Web Content";


const DetailSite = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const { role } = useAuth();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [selectedCols, setSelectedCols] = useState("Contracts");
  const [reload, setreload] = useState(false);
  const [AddAllEmployees, setAddAllEmployees] = useState(false);
  const [reloadEmployees, setReloadEmployees] = useState(false);
  const [open, setOpen] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [row, setRow] = useState();
  const [openRateEdit, setOpenRateEdit] = useState(false);

  const [index, setIndex] = useState(0);

  const {
    state: {
      selected: siteInfo,
      listEmployees,
      EmployeesCount,
      EmployeesPage,
      EmployeesPerPage,
      EmployeesTotalSize,
      listRoleList,
      selectedSMS,
    },
    fetchOne,
    fetchEmployeesSiteList,
    fetchRoleList,
    dispatch,
    fetchOneSMS,
    removeRole,
    updateRole,
  } = useSite();
  const { removeRoleRate } = useEmployees();
  const {
    state: { list: listContract },
    fetchList: fetchContracts,
    remove: rc,
    edit: editContract,
  } = useContract();
  const {
    state: { list: listGates },
    fetchList: fetchGates,
    remove: removeGate,
    edit: editGate,
  } = useGate();
  const {
    state: { list: listDiscount },
    fetchList: fetchDiscounts,
    remove: removeDisCount,
    edit: editDiscount,
  } = useDisCount();
  const {
    state: { list: listZones },
    fetchList: fetchZones,
    remove: removeZone,
    edit: editZone,
  } = useZone();
  const {
    state: { list: listAccounts },
    fetchList: fetchAccounts,
    remove: removeAccount,
    edit: editAccount,
  } = useAccount();
  const {
    state: { list: listVoidReasons },
    fetchList,
    remove: removeReason,
    edit: editReason,
  } = useVoidReason();
  const {
    state: { list: listTemplate },
    fetchList: fetchTemplates,
    remove: removeTemplate,
  } = useTemplateMess();
  const {
    state: { selected: webContent },
    fetchOne: fetchWebContent,
  } = useWebContent();

  const tabs = useMemo(
    () => [
      role !== "Site" && {
        title: TAB_CONTRACTS,
        num: siteInfo?.contractsCount ?? null,
      },
      { title: TAB_EMPLOYEES, num: siteInfo?.employeeNumber },
      { title: TAB_GATES, num: siteInfo?.gatesCount ?? null },
      { title: TAB_DISCOUNT, num: siteInfo?.discountsCount ?? null },
      { title: TAB_ZONES, num: siteInfo?.zonesCount ?? null },
      { title: TAB_ACCOUNT, num: siteInfo?.compAccountsCount ?? null },
      { title: TAB_ROLES, num: siteInfo?.roleRatesCount ?? null },
      {
        title: TAB_TEMPLATE_MESSAGES,
        num: siteInfo?.messageTemplatesCount ?? null,
      },
      { title: TAB_VOID_REASONS, num: siteInfo?.voidReasonsCount ?? null },
      { title: TAB_SMS_PROVIDERS },
      { title: TAB_WEB_CLIENT },
    ],
    [
      role,
      listContract,
      EmployeesTotalSize,
      listGates,
      listDiscount,
      listZones,
      listAccounts,
      listRoleList,
      listVoidReasons,
      listTemplate,
    ],
  );

  const safeFetch = async (fetchFn, errorMsg) => {
    setError(null);
    try {
      await fetchFn();
    } catch (err) {
      setError({ title: err?.errors.message ?? errorMsg });
    }
  };
  useEffect(() => {
    if (!id) return;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        await fetchOne(id);
      } catch (err) {
        setError(err?.message ?? "Failed to load site details");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);
  useEffect(() => {
    if (selectedCols === TAB_CONTRACTS && id) {
      safeFetch(() => fetchContracts(id), "Failed to load contracts");
    }
  }, [selectedCols, id]);

  // ========== 3. Employees ==========
  useEffect(() => {
    if (selectedCols === TAB_EMPLOYEES && id) {
      safeFetch(
        () => fetchEmployeesSiteList(id, EmployeesPage, EmployeesPerPage),
        "Failed to load employees",
      );
    }
  }, [selectedCols, id, EmployeesPage, EmployeesPerPage, reloadEmployees]);
  useEffect(() => {
    if (selectedCols === TAB_GATES && id) {
      safeFetch(() => fetchGates(id), "Failed to load gates");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_DISCOUNT && id) {
      safeFetch(() => fetchDiscounts(id), "Failed to load discounts");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_ZONES && id) {
      safeFetch(() => fetchZones(id), "Failed to load zones");
    }
  }, [selectedCols, id]);

  // ========== 7. Accounts ==========
  useEffect(() => {
    if (selectedCols === TAB_ACCOUNT && id) {
      safeFetch(() => fetchAccounts(id), "Failed to load accounts");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_ROLES && id) {
      safeFetch(() => fetchRoleList(id), "Failed to load roles");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_VOID_REASONS && id) {
      safeFetch(() => fetchList(id), "Failed to load void reasons");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_TEMPLATE_MESSAGES && id) {
      safeFetch(() => fetchTemplates(id), "Failed to load templates");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_SMS_PROVIDERS && id) {
      safeFetch(() => fetchOneSMS(id), "Failed to load SMS providers");
    }
  }, [selectedCols, id]);
  useEffect(() => {
    if (selectedCols === TAB_WEB_CLIENT && id) {
      safeFetch(() => fetchWebContent(id), "Failed to load web content");
    }
  }, [selectedCols, id]);

  const currentData = useMemo(() => {
    const tabDataMap = {
      [TAB_CONTRACTS]: listContract,
      [TAB_EMPLOYEES]: listEmployees,
      [TAB_GATES]: listGates,
      [TAB_DISCOUNT]: listDiscount,
      [TAB_ZONES]: listZones,
      [TAB_ACCOUNT]: listAccounts,
      [TAB_ROLES]: listRoleList,
      [TAB_TEMPLATE_MESSAGES]: listTemplate,
      [TAB_VOID_REASONS]: listVoidReasons,
    };
    return tabDataMap[selectedCols] ?? undefined;
  }, [
    selectedCols,
    listContract,
    listEmployees,
    listGates,
    listDiscount,
    listZones,
    listAccounts,
    listRoleList,
    listTemplate,
    listVoidReasons,
  ]);
  const getCols = useMemo(() => {
    switch (selectedCols) {
      case "Contracts":
        return [
          {
            label: "File Name",
            name: "",
            headTextLeft: true,
            textLeft: true,
            customRender: DownloadLink,
          },
          {
            label: "Start Date",
            name: "startDate",
            editable: true,
            helperText: "not empty",
            checkable: true,
            type: "date",
            customRender: StartContract,
          },
          {
            label: "End Date",
            name: "endDate",
            editable: true,
            checkable: true,
            helperText: "not empty",
            type: "date",
            customRender: EndContract,
          },
          {
            label: "First Reminder",
            name: "firstReminder",
            editable: true,
            checkable: true,
            helperText: "not empty",
            customRender: FirstReminderCell,
            type: "date",
          },
          {
            label: "Second Reminder",
            name: "secondReminder",
            editable: true,
            checkable: true,
            helperText: "not empty",
            customRender: LastReminder,
            type: "date",
          },
          {
            label: "Contract Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Employees":
        return [
          { label: "Employee", name: "employeeName" },
          { label: "Role", customRender: EmployeeRoles },
          {
            label: "Hourly Rate",
            customRender: EmployeeHourlyRate,
            multiRow: true,
          },
          { label: "Zones", customRender: EmployeeZones, multiRow: true },
          { label: "Update Date", customRender: EmployeeUpdateDate },
        ];
      case "Gates":
        return [
          {
            label: "Gate Name",
            name: "title",
            headTextLeft: true,
            textLeft: true,
            editable: true,
            checkable: true,
            helperText: "not empty",
          },
          {
            label: "Type",
            name: "typeId",
            customRender: StyledType,
            editable: true,
          },
          {
            label: "Gate Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Discounts":
        return [
          {
            label: "Discount Discription",
            name: "description",
            headTextLeft: true,
            textLeft: true,
            editable: true,
            checkable: true,
            helperText: "not empty",
          },
          {
            label: "Discount Value",
            name: "discount",
            customRender: StyledType,
            editable: true,
            checkable: true,
            number: true,
            helperText: "not empty or zero value",
          },
          {
            label: "Discount Status",
            name: "isActive",
            editable: true,
            customRender: ActiveCell,
            helperText: "discount must be greater than 0",
          },
        ];
      case "Zones":
        return [
          {
            label: "Site Zone Name",
            name: "title",
            headTextLeft: true,
            textLeft: true,
            editable: true,
            checkable: true,
            helperText: "not empty",
          },
          {
            label: "Site Zone Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Accounts":
        return [
          { label: "Account Name", name: "accountName", editable: true },
          {
            label: "Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Roles":
        return [
          { label: "Role", name: "roleId", headTextLeft: true, textLeft: true },
          {
            label: "Rate",
            name: "hourlyRate",
            headTextLeft: true,
            textLeft: true,
            editable: true,
            checkable: true,
            helperText: "Wrong Data",
          },
          { label: "Update Date", name: "updateDate" },
        ];
      case "Template Messages":
        return [
          { label: "Title", name: "title", headTextLeft: true, textLeft: true },
          { label: "Type", name: "smsTypeName" },
          {
            label: "Content",
            name: "",
            customRender: RenderMess,
            textLeft: true,
          },
          {
            label: "Template Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      case "Void Reasons":
        return [
          {
            label: "Void Reason",
            name: "reason",
            headTextLeft: true,
            textLeft: true,
            editable: true,
          },
          {
            label: "Reason Status",
            name: "isActive",
            customRender: ActiveCell,
            editable: true,
          },
        ];
      default:
        return undefined;
    }
  }, [selectedCols]);

  const handleAdd = useCallback(
    (name) => {
      const routes = {
        Contracts: "AddContract",
        Gates: "AddGate",
        Discounts: "AddDiscount",
        Zones: "AddZone",
        Accounts: "AddAccount",
        Roles: "AddRole",
        "Template Messages": "AddTemplateMessage",
        "Void Reasons": "AddVoidReason",
      };
      const route = routes[name];
      if (route) navigate(`/sites/SiteDetail/${id}/${route}`);
    },
    [id, navigate],
  );

  const tableFilters = useMemo(
    () => ({
      pagination: selectedCols === "Employee",
      page: selectedCols === "Employee" ? EmployeesPage : undefined,
      ...((role === "Company" || role === "Admin") &&
      selectedCols !== "Employees"
        ? { add: () => handleAdd(selectedCols), search: (e) => console.log(e) }
        : role === "Site" &&
            selectedCols !== "Employees" &&
            selectedCols !== "Contracts"
          ? {
              add: () => handleAdd(selectedCols),
              search: (e) => console.log(e),
            }
          : { addFromSite: () => setAddAllEmployees((prev) => !prev) }),
    }),
    [role, selectedCols, EmployeesPage, handleAdd],
  );
  const handleDetail = useCallback(
    (ID) => {
      navigate(`/sites/SiteDetail/${id}/SiteZoneDetails/${ID}`);
    },
    [id, navigate],
  );
  const handleDelete = useCallback(
    async (ID, row) => {
      const handlers = {
        Contracts: { fn: () => rc(ID), errorLabel: "Contract" },
        Gates: { fn: () => removeGate(ID), errorLabel: "Gate" },
        Discounts: { fn: () => removeDisCount(ID), errorLabel: "Discount" },
        Zones: { fn: () => removeZone(ID), errorLabel: "Zone" },
        Accounts: { fn: () => removeAccount(ID), customError: true },
        Roles: { fn: () => removeRole(id, ID), errorLabel: "Roles" },
        "Template Messages": {
          fn: () => removeTemplate(ID),
          errorLabel: "Template Messages",
        },
        "Void Reasons": {
          fn: () => removeReason(ID),
          errorLabel: "Void Reasons",
        },
        Employees: {
          fn: async () => {
            try {
              await removeRoleRate(ID, id, row.roleId);
              setReloadEmployees((prev) => !prev);
            } catch (error) {
              window.scroll(0, 0);
              setError({ title: error.errors.message.toString() });
            }
          },
          errorLabel: "Employees",
        },
      };

      const handler = handlers[selectedCols];
      if (!handler) return;

      try {
        await handler.fn();
      } catch (error) {
        if (handler.customError) {
          setError({ title: error?.errors?.message || "An error occurred" });
        } else {
          setError({
            title: handleErrorResponse(error.status, handler.errorLabel),
          });
        }
      }
    },
    [
      selectedCols,
      id,
      rc,
      removeGate,
      removeDisCount,
      removeZone,
      removeAccount,
      removeRole,
      removeTemplate,
      removeReason,
      removeRoleRate,
    ],
  );

  const handleClose = useCallback(() => setOpen(false), []);
  const handleCloseAllEmployees = useCallback(
    () => setAddAllEmployees(false),
    [],
  );
  const handleSuccess = useCallback(() => setOpen(true), []);

  const handleEditRateClose = useCallback(() => {
    setOpenRateEdit(false);
    setReloadEmployees((prev) => !prev);
  }, []);

  const handleEdite = useCallback(
    async (e, ID) => {
      switch (selectedCols) {
        case "Contracts": {
          delete e[0].contractUrl;
          delete e[0].id;
          try {
            await editContract(e[0], ID);
            handleSuccess();
            setreload((prev) => !prev);
            fetchOne(id);
            setError(null);
          } catch (error) {
            setError({ title: handleErrorResponse(error.status, "Contract") });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Employees":
          setOpenRateEdit(true);
          setRow(ID);
          break;
        case "Gates": {
          delete e[0].id;
          delete e[0].typeName;
          try {
            await editGate(e[0], ID);
            handleSuccess();
            setreload((prev) => !prev);
            fetchOne(id);
            setError(null);
          } catch (error) {
            setError({ title: handleErrorResponse(error.status, "Gate") });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Discounts": {
          delete e[0].id;
          try {
            await editDiscount(e[0], ID);
            handleSuccess();
            setreload((prev) => !prev);
            fetchOne(id);
            setError(null);
          } catch (error) {
            setError({ title: handleErrorResponse(error.status, "Discount") });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Zones": {
          delete e[0].id;
          try {
            await editZone(e[0], ID);
            handleSuccess();
            setreload((prev) => !prev);
            setError(null);
            fetchOne(id);
          } catch (error) {
            setError({ title: handleErrorResponse(error.status, "Zone") });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Accounts": {
          try {
            delete e[0].id;
            editAccount(e[0], ID);
          } catch (error) {
            setError({
              title: handleErrorResponse(error.status, "Member Plan"),
            });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Roles": {
          let sid;
          delete e[0].role;
          if (!sid) sid = e[0].siteId;
          try {
            await updateRole(e[0], sid);
            handleSuccess();
            setreload((prev) => !prev);
            fetchOne(id);
            setError(null);
          } catch (error) {
            setError({
              title: handleErrorResponse(error.status, "Member Plan"),
            });
            setreload((prev) => !prev);
            fetchOne(id);
          }
          break;
        }
        case "Void Reasons": {
          delete e[0].id;
          try {
            await editReason(e[0], ID);
            setreload((prev) => !prev);
            fetchOne(id);
            setError(null);
          } catch (error) {
            setError({
              title: handleErrorResponse(error.status, "Member Plan"),
            });
            setreload((prev) => !prev);
            fetchList(id);
          }
          break;
        }
        case "Template messages":
          navigate(`/sites/SiteDetail/${e}/update`);
          break;
        default:
          break;
      }
    },
    [
      selectedCols,
      id,
      editContract,
      editGate,
      editDiscount,
      editZone,
      editAccount,
      updateRole,
      editReason,
      fetchList,
      navigate,
      handleSuccess,
    ],
  );
  const tableActions = useMemo(() => {
    const base = {
      selectedCols: true,
      inTableEdit:
        selectedCols !== "Template messages" && selectedCols !== "Employees",
      hourlyRate: selectedCols === "Employees",
      edit: handleEdite,
      delete: handleDelete,
    };
    if (role === "Company" || role === "Admin") return base;
    if (role === "Site" && selectedCols !== "Contracts") return base;
    return false;
  }, [role, selectedCols, handleEdite, handleDelete]);

  

  return (
    <>
      <Typography variant="Poster" component="h4">
        Site Details
      </Typography>
      
      <InfoSite SiteInfo={siteInfo} />
      <div style={{ margin: "30px 20px" }}>
        <TabsList
          tabs={tabs}
          selectedCols={selectedCols}
          setSelectedCols={setSelectedCols}
          dispatch={dispatch}
        />
        {error && (
          <Alert severity="error" sx={{ m: 3 }}>
            <ErrorsList error={error} />
          </Alert>
        )}
      </div>
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        {selectedCols === TAB_SMS_PROVIDERS &&
          (selectedSMS && Object.keys(selectedSMS).length > 0 ? (
            <SMSInfo SMSInfo={selectedSMS} />
          ) : (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "15px" }}>
                No Provider Yet
                {(role === "Admin" || role === "Company") && (
                  <Button
                    sx={{
                      background: "white",
                      color: theme.color.blackBackground,
                      border: `1px solid ${theme.color.blackBackground}`,
                      "&:hover": { background: "white" },
                      ml: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={() => navigate("add")}
                  >
                    Add +
                  </Button>
                )}
              </div>
            </div>
          ))}
      </Box>
      <CustomTable
        empty={currentData?.length === 0}
        cols={getCols}
        data={currentData}
        filters={tableFilters}
        actions={tableActions}
        showButton={true}
        moreOptions={
          selectedCols === "Zones" ? { detail: handleDetail } : false
        }
        title={selectedCols}
        isPagination={selectedCols === "Employees"}
        page={EmployeesPage}
        rowsPerPage={EmployeesPerPage}
        count={EmployeesCount}
        setIndex={setIndex}
        Index={index}
        roleId={roleId}
        dispatch={dispatch}
        setRoleId={setRoleId}
        inSiteDetails={true}
        selectedCols="Employees"
      />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {selectedCols === TAB_WEB_CLIENT &&
          (webContent && Object.keys(webContent).length > 0 ? (
            <WebContentInfo webContentInfo={webContent} />
          ) : (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "15px" }}>
                No Web Content Yet
                <Button
                  sx={{
                    background: "white",
                    color: theme.color.blackBackground,
                    border: `1px solid ${theme.color.blackBackground}`,
                    "&:hover": { background: "white" },
                    ml: "10px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => navigate("addWebContent")}
                >
                  Add +
                </Button>
              </div>
            </div>
          ))}
      </div>
      <ModalBox
        open={open}
        operation="edit"
        handleClose={handleClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
      />
      <ModalBox
        open={AddAllEmployees}
        Send={true}
        row={siteInfo}
        handleClose={handleCloseAllEmployees}
        text="You will add all employees from this site"
        name={`${selectedCols}`}
      />
      <ModalBox
        open={openRateEdit}
        row={row}
        roleId={roleId}
        setRoleId={setRoleId}
        operation="edit"
        handleClose={handleEditRateClose}
        text="The update operation has been completed successfully.."
        name={`${selectedCols}`}
        editRoleZoneEmp={true}
        inSiteDetails={true}
      />
    </>
  );
};

export default React.memo(DetailSite);
